<template>
    <main-toast/>
    <component :is="layout" />
</template>

<script>
    import Dashboard from '@/layouts/dashboard.vue';
    import Blank from '@/layouts/blank.vue';
    export default {
        components: {
            Dashboard,
            Blank
        },
        data() {
            return {
                layout: null,
            };
        },
        created() {
            this.syncLayout(this.$route);
        },
        watch: {
            $route(to) {
                this.syncLayout(to);
            },
        },
        methods: {
            syncLayout(to) {
                this.layout = to.meta.layout || 'Dashboard';
            },
        },
    };
</script>